import { gql } from '../../types/__codegen__/sanity';

export const GET_ARTICLE_IDENTIFIERS = gql(`
  query getArticles($insuranceTypes: [String!]) {
    allArticle(where: { insuranceType: { identifier: { current: { in: $insuranceTypes } } } }) {
      identifier {
        current
      }
      insuranceType {
        identifier {
          current
        }
      }
    }
  }
`);

export const GET_TOTAL_ARTICLES_FOR_COUNT = gql(`
  query getTotalArticlesCount {
    allArticle {
      _id
    }
  }
`);

export const GET_TOTAL_ARTICLES_FOR_COUNT_BY_TYPE = gql(`
  query getTotalArticlesCountByType($insuranceType: String) {
    allArticle(where: { insuranceType: { identifier: { current: { eq: $insuranceType } } } }) {
      _id
    }
  }
`);
